import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { Input, SmallHeader } from '../index.js';
import q from '@debbie/cortex/dist/query.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
const EntityUpdater = (props) => {
    const { collector } = props;
    if (!collector)
        return null;
    const lang = useSelector((s) => s.lang);
    const [loadingEntity, setLoadingEntity] = useState(false);
    const [entity, setEntity] = useState(
    // @ts-ignore
    collector[props.entity]);
    const save = async () => {
        {
            setLoadingEntity(true);
            try {
                await collectorsAPI.update(collector.collectorId, {
                    [props.entity]: entity,
                });
                q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
            }
            catch (error) {
                alert(error);
            }
            setLoadingEntity(false);
        }
    };
    useEffect(() => {
        // @ts-ignore
        if (collector) {
            // @ts-ignore
            setEntity(collector[props.entity]);
        }
        // @ts-ignore
    }, [collector[props.entity]]);
    return (React.createElement("div", null,
        React.createElement(SmallHeader, null, 
        // @ts-ignore
        lang.collectors[`${props.entity}Placeholder`]),
        React.createElement(Input
        // @ts-ignore
        , { 
            // @ts-ignore
            placeholder: lang.collectors[`${props.entity}Placeholder`], value: entity || '', onChange: (e) => setEntity(e.target.value || null), onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    save();
                }
            }, disabled: props.disabled, button: 
            // @ts-ignore
            entity !== collector[props.entity]
                ? {
                    value: lang.collectors.updateEntity,
                    loading: loadingEntity,
                    onClick: save,
                }
                : undefined })));
};
export default EntityUpdater;
//# sourceMappingURL=EntityUpdater.js.map